// extracted by mini-css-extract-plugin
export default {"smallText":"SmallText_smallText__zrkK1"};